<template>
  <div class="headerPage">
    <div class="head_title flex-between" v-if="$route.meta.showNav">
      <div class="home flex-rowl" @click="handleHome">
        <div class="home_icon">
          <el-image
            style="width: 100%; height: 100%"
            :src="require('@/assets/images/home_icon.png')"
            
          ></el-image>
        </div>
        <p>Home</p>
      </div>
      <p>WINK SShoWP Sales Precinct Resource · management system</p>
      <el-dropdown class="country-select" @command="handleDropdown">
        <div class="selected-country el-dropdown-link flex-between">
          <div class="content flex-rowl">
            <span class="iconfont icon-diqiu"></span>
            <span class="flag"
              ><img style="width: 26px; height: 17px" :src="COUNTRY.icon"
            /></span>
            <span>{{
              COUNTRY.countryname_e
                ? COUNTRY.countryname_e
                : COUNTRY.countryname
            }}</span>
          </div>
          <div class="arr">
            <i class="iconfont icon-sanjiaojiantoushang"></i>
          </div>
        </div>
        <el-dropdown-menu class="country-list">
          <el-dropdown-item
            class="country-item flex-rowl"
            v-for="(country, index) in countries"
            :key="index"
            :command="country"
            ><img style="width: 26px; height: 17px" :src="country.icon" />
            <p>
              {{
                country.countryname_e
                  ? country.countryname_e
                  : country.countryname
              }}
            </p></el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="site_nav flex-between" v-else-if="$route.meta.isVisitors">
      <div class="left flex-rowl">
        <div class="logo flex-colc" @click="handleGo(1, 'home')">
          <el-image
            style="width: 100%; height: 100%"
            :src="require('@/assets/images/publice_logo.png')"
          ></el-image>
        </div>
      </div>

      <div class="right flex-rowr">
        <div class="order_center flex-rowr">
          <div class="main_user_icon">
            <el-image
              style="width: 100%; height: 100%"
              :src="require('@/assets/images/main_user_icon.png')"
            ></el-image>
          </div>
          <span>guest001</span>
        </div>
        <div
          class="exit flex-rowl"
          style="margin-left: 20px"
          @click="handleExit"
        >
          <i class="iconfont icon-tuichu"></i>
          <span>{{ $t("Register") }}</span>
        </div>
        <el-dropdown class="country-select" @command="handleDropdown">
          <div class="selected-country el-dropdown-link flex-between">
            <div class="content flex-rowl">
              <span class="iconfont icon-diqiu"></span>
              <span class="flag"
                ><img style="width: 26px; height: 17px" :src="COUNTRY.icon"
              /></span>
              <span>{{
                COUNTRY.countryname_e
                  ? COUNTRY.countryname_e
                  : COUNTRY.countryname
              }}</span>
            </div>
            <div class="arr">
              <i class="iconfont icon-sanjiaojiantoushang"></i>
            </div>
          </div>
          <el-dropdown-menu class="country-list">
            <el-dropdown-item
              class="country-item flex-rowl"
              v-for="(country, index) in countries"
              :key="index"
              :command="country"
              ><img style="width: 26px; height: 17px" :src="country.icon" />
              <p>
                {{
                  country.countryname_e
                    ? country.countryname_e
                    : country.countryname
                }}
              </p></el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="site_nav flex-between" v-else>
      <div class="left flex-rowl">
        <div class="logo flex-colc" @click="handleGo(1, 'home')">
          <el-image
            style="width: 100%; height: 100%"
            :src="require('@/assets/images/publice_logo.png')"
          ></el-image>
        </div>
        <!-- 
                权限控制，符合以下条件的不可视
                1、用户基础权限类型：游客（limittype=3）
                2、下拉选中的国家和当前账户的责任区域不匹配
                -->
        <div
          class="menu_list flex-rowl"
          v-if="
            USERINFO
              ? USERINFO.limittype != 3 &&
                USERINFO.countryids
                  .split(',')
                  .indexOf(COUNTRY.countryid.toString()) > -1
              : ''
          "
        >
          <div class="menu_item flex-rowc" @click="handleGo(1, 'orderList')">
            <div class="cart_icon">
              <el-image
                style="width: 100%; height: 100%"
                :src="require('@/assets/images/cart_icon.png')"
              ></el-image>
            </div>
            <span>{{ $t("Order Center") }}</span>
          </div>
          <div
            class="menu_item flex-rowl"
            @click="handleGo(1, 'selectMsgList')"
          >
            <div class="hot_icon">
              <el-image
                style="width: 100%; height: 100%"
                :src="require('@/assets/images/hot_icon.png')"
              ></el-image>
            </div>

            <span>{{
              $t("Selection information (recommended product example)")
            }}</span>
          </div>
        </div>
      </div>

      <div class="right flex-rowr">
        <div class="order_center flex-rowr" v-if="USERINFO.limittype != 3">
          <div class="main_user_icon">
            <el-image
              style="width: 100%; height: 100%"
              :src="require('@/assets/images/main_user_icon.png')"
            ></el-image>
          </div>

          <span>{{
            USERINFO.truename ? USERINFO.truename : USERINFO.username
          }}</span>
        </div>
        <div
          class="manage_center flex-rowr"
          @click="handleGoManage"
          v-if="USERINFO.limittype != 3"
        >
          <i class="iconfont icon-dingdan"></i>管理中心
        </div>
        <div class="exit flex-rowl" @click="handleExit">
          <i class="iconfont icon-tuichu"></i>
          <span v-if="USERINFO.limittype == 3">{{ $t("Register") }}</span
          ><span v-else>{{ $t("Logout") }}</span>
        </div>
        <el-dropdown class="country-select" @command="handleDropdown">
          <div class="selected-country el-dropdown-link flex-between">
            <div class="content flex-rowl">
              <span class="iconfont icon-diqiu"></span>
              <span class="flag"
                ><img style="width: 26px; height: 17px" :src="COUNTRY.icon"
              /></span>
              <span>{{
                COUNTRY.countryname_e
                  ? COUNTRY.countryname_e
                  : COUNTRY.countryname
              }}</span>
            </div>
            <div class="arr">
              <i class="iconfont icon-sanjiaojiantoushang"></i>
            </div>
          </div>
          <el-dropdown-menu class="country-list">
            <el-dropdown-item
              class="country-item flex-rowl"
              v-for="(country, index) in countries"
              :key="index"
              :command="country"
              ><img style="width: 26px; height: 17px" :src="country.icon" />
              <p>
                {{
                  country.countryname_e
                    ? country.countryname_e
                    : country.countryname
                }}
              </p></el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import storage from "../utils/storage";
import { encryptstringadd, getCountry } from "../api/api";
import { getExrateList } from "../api/shop";
export default {
  name: "myHeader",
  data() {
    return {
      list: [
        {
          txt: "首页",
          url: "/home",
        },
        {
          txt: "管理",
          url: "/manage",
        },
        {
          txt: "数据",
          url: "",
        },
        {
          txt: "帮助",
          url: "",
        },
        // {
        //   txt: "消息",
        //   url: "",
        //   // url: "/message",
        // },
        {
          txt: "工具",
          url: "/ToolManageIndex",
        },
        {
          txt: "我的",
          url: "/mine",
        },
      ],

      showCountry: false,
      countries: [],
    };
  },
  created() {},
  computed: {
    ...mapState(["USERINFO", "OPENID", "COUNTRY"]),
  },
  mounted() {
    this.getCountryExrateList();
  },
  methods: {
    handleExit() {
      let { limittype } = this.USERINFO;
      this.$confirm(this.$t("Logout?"), this.$t("suggestion"), {
        confirmButtonText: "yes",
        cancelButtonText: "no",
        type: "warning",
      }).then(() => {
        // storage.removeAll();

        storage.remove("OPENID");
        storage.remove("TOKEN");
        storage.remove("USERINFO");
        this.$store.commit("updateToken", "");
        // 游客账户
        if (limittype == 3) {
          this.$router.push("/register");
        } else {
          this.$router.push("/login");
        }
      });
    },

    handleGo(type, name) {
      if (type == 1) {
        this.$router.push({
          name,
        });
      } else {
        this.$message.warning(this.$t("Opening soon"));
      }
    },

    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },

    // 获取国家和汇率
    async getCountryExrateList() {
      // 获取国家
      const res1 = await getCountry();

      // 获取汇率
      const res2 = await getExrateList();
      // console.log(res2,'===222res2');

      // 合并国家和汇率
      let countryExrateList = res1.map((item) => {
        let exrate = res2.list.find((v) => v.countryid == item.countryid);
        return {
          ...item,
          ...exrate,
        };
      });

      let filterArr = countryExrateList.filter(
        (v) => v.homeurl != "" && v.homeurl
      );
      this.countries = filterArr;
      this.$store.dispatch("updateCountryList", filterArr);
      // 如果COUNTRY为空，设置默认值
      if (!storage.get("COUNTRY")) {
        let country = filterArr.find((v) => v.countryid == 8);
        this.$store.dispatch("updateCountry", country);
        return;
      }
    },

    // 获取国家
    getCountry() {
      getCountry().then((res) => {
        let filterArr = res.filter((v) => v.homeurl != "" && v.homeurl);
        this.countries = filterArr;
        this.$store.dispatch("updateCountryList", filterArr);
        // 如果COUNTRY为空，设置默认值
        if (!storage.get("COUNTRY")) {
          let country = filterArr.find((v) => v.countryid == 8);
          this.$store.dispatch("updateCountry", country);
          return;
        }
      });
    },

    handleDropdown(e) {
      this.$store.dispatch("updateCountry", e);
      // 更新 Vuex store 中的语言状态
      this.$store.dispatch("updateLanguage", e.directory);

      // 更新 VueI18n 实例的语言
      this.$i18n.locale = e.directory;
      // 如果this.$route.path 包含 /home 或者 /login 或者 /register 则重新加载当前页面，否则跳转到 /home
      if (this.$route.path.includes("/HomeVisitors")) {
        return;
      }
      if (
        this.$route.path.includes("/home") ||
        this.$route.path.includes("/login") ||
        this.$route.path.includes("/register")
      ) {
        window.location.reload(); // 重新加载当前页面
        return;
      } else {
        this.$router.push({
          path: "/home",
        });
      }
    },

    // 跳转首页
    handleHome() {
      // 如果this.$route.path 包含 /register则跳转到login
      if (this.$route.path.includes("/register")) {
        this.$router.push({
          path: "/login",
        });
        return;
      }
    },

    // 管理中心
    handleGoManage() {
      this.$router.push({
        name: "manageCenterIndex",
      });
    },
  },
};
</script>
<style lang="less" scoped>
.headerPage {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1001;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.05);
  .head_title {
    height: 30px;
    // height: 30px;
    background: #e6e6e6;
    font-size: 12px;
    color: #666666;
    letter-spacing: 1px;
    font-family: "MontserratExtraLight", sans-serif; /* 使用引入的字体 */
    padding-left: 30px;
    box-sizing: border-box;
    .home {
      width: 180px;
      cursor: pointer;
      .home_icon {
        width: 19px;
        height: 19px;
      }
      p {
        font-size: 16px;
        color: #010101;
        margin-left: 10px;
      }
    }
    .country-select {
      position: relative;
      display: inline-block;
      width: 210px;
      .selected-country {
        height: 30px;
        cursor: pointer;
        padding: 0 20px 0 5px;
        box-sizing: border-box;
        .content {
          .icon-diqiu {
            margin-right: 8px;
          }
          .flag {
            margin-right: 7px;
          }
        }
        .arr {
          .iconfont {
            font-size: 14px;
          }
        }
      }
    }

    .country-list {
      position: absolute;
      top: 100%;
      left: 0;
      z-index: 1;
      background-color: #e6e6e6;
      width: 210px;
      max-height: 50vh;
      overflow-y: scroll;
      .country-item {
        height: 46px;
        padding-left: 29px;
        box-sizing: border-box;
        cursor: pointer;
        &:hover {
          background-color: #f0f0f0;
        }
        p {
          margin-left: 7px;
        }
      }
    }
  }
  .site_nav {
    height: 60px;
    background: #f0f0f0;
    padding: 0 0 0 65px;
    font-size: 16px;
    color: #4b4b4b;
    .left {
      .logo {
        align-items: flex-start;
        cursor: pointer;
        width: 251px;
        height: 27px;
      }
      .menu_list {
        margin-left: 40px;
        .menu_item {
          margin-right: 30px;
          cursor: pointer;
          span {
            margin-left: 10px;
          }
          .cart_icon {
            width: 28px;
            height: 25px;
          }
          .hot_icon {
            width: 28px;
            height: 26px;
          }
        }
      }
    }
    .right {
      .user {
        margin-right: 170px;
        .icon-yonghu {
          font-size: 24px;
          margin-right: 5px;
        }
      }
      .main_user_icon {
        width: 26px;
        height: 25px;
      }
      .manage_center {
        margin: 0 25px;
        cursor: pointer;
        .icon-dingdan {
          font-size: 22px;
          margin-right: 3px;
        }
      }
      span {
        margin-left: 10px;
      }
      .exit {
        cursor: pointer;
        .icon-tuichu {
          font-size: 24px;
          margin-right: 14px;
        }
        span {
          margin-left: 0;
        }
      }
    }
  }
  .head_wrap {
    padding: 26px 65px;
    background: #fff;
    font-size: 18px;
    color: #000000;
    .icon {
      // margin-right: ;
      .icon-diejia {
        font-size: 20px;
        color: #515151;
      }
    }
    ul {
      li {
        padding: 0 7px 7px;
        margin: 0 28px;
        position: relative;
        cursor: pointer;
        &.active {
          &::after {
            display: inline-block;
            content: "";
            width: 100%;
            height: 6px;
            background: #292929;
            position: absolute;
            bottom: -7px;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
    }
  }

  // 响应式，1400px以下的屏幕
  @media screen and (max-width: 1400px) {
    .site_nav {
      font-size: 14px;
    }
  }
}
</style>